import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick/skeleton-brick';
import {Text, TextSize} from '@Components/text/text';
import {WEB_SOURCES_VARIANT_COPY} from '../web-sources/web-sources.types';
import type {WebSourcesSkeletonProps} from './web-sources-skeleton.types';
import {SKELETON_FAVICON_COUNT, SKELETON_FAVICON_SIZE} from './web-sources-skeleton.types';
import styles from './web-sources-skeleton.module.scss';

/**
 * Grey placeholder in the shape of the web-sources line: "Searching…" or "Reading link…" with a darker grey pulse, beside favicon
 * circles. All grey, so it never competes with the chat's coloured main loader above it.
 */
export function WebSourcesSkeleton({variant}: WebSourcesSkeletonProps): ReactElement {
  const {icon, loadingKey} = WEB_SOURCES_VARIANT_COPY[variant];

  return (
    <div className={styles.webSourcesSkeleton} role="group" aria-busy="true" aria-label={window.i18next.t('pmwjs_ai_chat_web_sources_title')}>
      <Icon icon={icon} size={IconSize.SIZE_ICON_16} className={styles.webSourcesSkeletonIcon} />
      <Text val={window.i18next.t(loadingKey)} size={TextSize.SM} className={styles.webSourcesSkeletonLabel} />
      <span className={styles.webSourcesSkeletonFavicons} aria-hidden="true">
        {Array.from({length: SKELETON_FAVICON_COUNT}, (_, faviconIndex) => (
          <SkeletonBrick key={faviconIndex} className={styles.webSourcesSkeletonFavicon} width={SKELETON_FAVICON_SIZE} height={SKELETON_FAVICON_SIZE} radius="50%" theme={SkeletonBrickTheme.LIGHT_TWO} />
        ))}
      </span>
    </div>
  );
}
